import { observer } from 'mobx-react-lite'
import { Typography } from 'shared/ui'

import { ModalLargeIcon } from 'shared/ui/Icon/ModalLargeIcon/ModalLargeIcon.tsx'
import { ModalTypeList } from 'shared/ui/Modal/store/types.ts'
import { type ForgotPasswordStore } from 'pages/auth/pages/forgot/ui/ForgotPassword'
import { AuthHeader } from 'pages/auth/ui/AuthHeader/AuthHeader.tsx'
import styles from './styles.module.scss'

type IFormProps = {
  store: ForgotPasswordStore
}

export const SuccessForm = observer(({ store }: IFormProps) => {
  return (
    <>
      <AuthHeader />
      <div className={styles.content}>
        <ModalLargeIcon type={ModalTypeList.SUCCESS} />
        <Typography
          marginTop={24}
          variant={'heading-lg'}
          ariaLabel={'title'}
          color={'var(--content-primary-primary)'}
        >
          Check your email
        </Typography>
        <Typography
          marginTop={8}
          variant={'body-lg-regular'}
          ariaLabel={'subtitle'}
          color={'var(--content-primary-tertiary)'}
        >
          If an account exists for this address, we have sent instructions to reset the password to:
        </Typography>
        <Typography
          variant={'body-lg-regular'}
          ariaLabel={'email'}
          color={'var(--content-primary-primary)'}
        >
          {store.email}
        </Typography>
      </div>
    </>
  )
})

export default SuccessForm
